export const getPriceDataWithDiscount = (
  priceData: {
    [key: string]: {
      price: number;
      basePrice: number;
      recurring: boolean;
      currency: string;
    };
  },
  discount:
    | {
        percentOff: number;
        amountOff: number;
      }
    | undefined
) => {
  if (!discount) {
    return priceData;
  }

  const newPriceData = Object.keys(priceData).reduce((acc, key) => {
    acc[key] = { ...priceData[key] };
    if (discount.percentOff) {
      acc[key].price = priceData[key].price * (1 - discount.percentOff / 100);
    } else {
      acc[key].price = priceData[key].price;
    }

    if (discount.amountOff) {
      acc[key].price = acc[key].price - discount.amountOff;
    } else {
      acc[key].price = acc[key].price;
    }

    return acc;
  }, {});

  return newPriceData;
};

export const ceilPriceToOneDecimal = (price: number) => {
  return Math.ceil(price * 10) / 10;
};
